import gql from "graphql-tag";


export const GET_ORDER_HISTORY = gql`
query ($orderId : String!){
  orderHistory(order_by: {createdAt: desc}, limit: 1,
   where: {_and: {orderId: {_eq: $orderId}}, difference: {_has_key: "internalstatus"}}) {
      id  
      createdAt
  }
}
`